import React, { useState } from "react";
import { Box, Typography, TextField, Button, Divider } from "@mui/material";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";

const TicketDetail = ({ ticket, onBack, onReply }) => {
  const [newMessage, setNewMessage] = useState("");
  const [ticketData, setTicketData] = useState({});
//   const [attachments, setAttachments] = useState([]);
const [input, setInput] = React.useState({
    "userId": JSON.parse(localStorage.getItem("user"))?._id,
    "userName": "Support Agent",
    "comment": "",
    "attachments": []
  })

  // ge params from the url
    const { id } = useParams();

    const getTicket = (id) => {
        // fetch ticket by id
        axios.get(`${process.env.REACT_APP_API_URL}/support-management/ticket/${id}`)
        .then((res) => {
            console.log(res.data);
            setTicketData(res.data.ticket);
        })
        .catch((err) => {
            console.log(err);
        });
    }

    React.useEffect(() => {
        getTicket(id);
    }, [id]);

  const handleReplySubmit = () => {
    // if (!newMessage.trim()) return;
    // onReply(ticket.id, newMessage);
    // setNewMessage("");
    const formData = new FormData();
    formData.append("userId", input.userId);
    formData.append("userName", input.userName);
    formData.append("comment", input.comment);
    input.attachments.forEach((file) => {
      formData.append("attachments", file);
    });

    axios.patch(`${process.env.REACT_APP_API_URL}/support-management/ticket/${id}/`, formData)
    .then((res) => {
        console.log(res.data);
        getTicket(id);
    })
    .catch((err) => {
        console.log(err);
    });
  };

//   const handleFileChange = (e) => {
//     const files = e.target.files;
//     setAttachments(files)
//     }

const handleChange = (e) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value
    })
  }

  const handleChangeFile = (e) => {
    // handle multiple files
    const files = e.target.files
    let attachments = []
    for (let i = 0; i < files.length; i++) {
      attachments.push(files[i])
    }
    console.log(attachments)
    setInput({
      ...input,
      attachments: attachments
    })
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Button variant="contained" color="primary" onClick={onBack}>
        Back to Tickets
      </Button>

      {/* Ticket Info */}
      <Box sx={{ display: "flex", gap: 3, alignItems: "center", mt: 2, mb: 3 }}>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Typography variant="h6">Ticket ID:</Typography>
            <Typography variant="body1">{ticketData?.ticketId || "N/A"}</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Typography variant="h6">Subject:</Typography>
            <Typography variant="body1">{ticketData?.subject || "N/A"}</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Typography variant="h6">Category:</Typography>
            <Typography variant="body1">{ticketData?.category || "N/A"}</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Typography variant="h6">Priority:</Typography>
            <Typography variant="body1">{ticketData?.priority || "N/A"}</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Typography variant="h6">Status:</Typography>
            <Typography
            variant="body1"
            sx={{ color: ticketData?.status === "Open" ? "error.main" : "success.main" }}
            >
            {ticketData?.status || "N/A"}
            </Typography>
        </Box>
        </Box>

    <Divider />

      {/* Reply Section */}
    <Box sx={{ mt: 3, mb: 3 }}>
    <Typography variant="h6">Reply:</Typography>
    
    {/* Reply Text Field */}
    <TextField
        fullWidth
        multiline
        rows={4}
        variant="outlined"
        placeholder="Type your reply here..."
        value={input.comment}
        onChange={(e) => handleChange(e)}
        sx={{ mt: 2 }}
        name="comment"
    />
    
    {/* Attachment Upload */}
    <Box sx={{ mt: 2 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Attach Files:</Typography>
        <input
        type="file"
        multiple
        onChange={(e) => handleChangeFile(e)}
        style={{ display: "block" }}
        />
    </Box>
    
    {/* File Preview */}
    <Box sx={{ mt: 2 }}>
        {/* {input?.attachments.map((file, index) => (
        <Typography key={index} variant="body2">
            {file.name}
        </Typography>
        ))} */}
    </Box>
    
    {/* Submit Button */}
    <Button
        variant="contained"
        color="primary"
        sx={{ mt: 2 }}
        onClick={handleReplySubmit}
    >
        Send Reply
    </Button>
    </Box>

    <Divider />

      {/* Previous Messages */}
      <Box sx={{ mt: 3, mb: 3 }}>
  <Typography variant="h6">Previous Messages:</Typography>
  <Box
    sx={{
      maxHeight: 400,
      overflowY: "auto",
      border: "1px solid #ccc",
      p: 2,
      borderRadius: 1,
    }}
  >
    {ticketData?.comments && ticketData?.comments.length > 0 ? (
      ticketData?.comments
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .map((msg, index) => (
        <React.Fragment key={index}>
          <Box sx={{ mb: 2, mt: 2 }}>
            {/* User Section */}
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                color: msg?.user?.role === "admin" ? "primary.main" : "secondary.main",
              }}
            >
              {msg?.user?.name || "Unknown User"} 
              {/* ÷({msg?.user?.role || "User"}) */}
            </Typography>

            {/* Date */}
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 1 }}>
              {moment(msg?.createdAt).format("MMM DD, YYYY hh:mm A")}
            </Typography>

            {/* Message Text */}
            <Typography variant="body1" sx={{ mb: 1 }}>
              {msg?.comment}
            </Typography>

            {/* Attachments Section */}
            {msg?.attachments && msg?.attachments.length > 0 && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>Attachments:</Typography>
                {msg?.attachments.map((file, fileIndex) => (
                <Typography key={fileIndex} variant="body2" sx={{ ml: 2 }}>
                    <a
                    href={`${process.env.REACT_APP_API_URL}/${file.path}`} // Use file.path directly
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    {file.filename}
                    </a>
                </Typography>
                ))}
              </Box>
            )}
          </Box>
          <Divider />
        </React.Fragment>
      ))
    ) : (
      <Typography>No previous messages.</Typography>
    )}
  </Box>
</Box>
    </Box>
  );
};

export default TicketDetail;